import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import SearchBox from "../dashboard/searchbox";
import NotificationMenu from "../dashboard/notification";
import Tooltip from "@mui/material/Tooltip";
import Avtr from "../../images/avatar.png";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Img from "../../images/logo 01.png";
import { mainListItems } from "../dashboard/listItems";
import { secondaryListItems } from "../dashboard/listItems";
import Avatar from "@mui/material/Avatar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import LogoImg from "../../images/logo 01.png";
import { Link, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
const drawerWidth = 240;
const settings = ["Profile", "Wallet", "Dashboard", "Logout"];


function DashboardDrawer() {
  const navigate = useNavigate();
  const handleNavigation = (setting) => {
    // Navigate to the appropriate route based on the clicked setting
    if (setting === "Profile") {
      navigate("/setting", { replace: true });
    } else if (setting === "Wallet") {
      navigate("/wallet", { replace: true });
    } else if (setting === "Dashboard") {
      navigate("/dashboard", { replace: true });
    } else if (setting === "Logout") {
      localStorage.clear();
      window.location.reload();
    }
  };
  const handleMainLogoClick = () => {
    navigate("/");
  };
  const [mobileOpen, setMobileOpen] = React.useState();
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  React.useEffect(() => {
    
  });


  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <CssBaseline />
      <AppBar position="fixed" component="nav" sx={{ background: "white" }}>
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "block", lg: "none" },
              color: "black!important",
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="body1"
            color="inherit"
            noWrap
            sx={{
              flexGrow: 1,
              textAlign: "left",
              color: "black",
              fontWeight: "600",
              fontSize: "18px",
            }}
          >
            <span>Welcome {localStorage.getItem("name")}!</span>
            <Typography
              component="h1"
              variant="caption"
              color="inherit"
              noWrap
              sx={{
                flexGrow: 1,
                textAlign: "left",
                color: "grey",
                fontSize: "12px",
                position: "relative",
                top: "-0.3rem",
              }}
            >
              Hope you are healthy and happy today...
            </Typography>
          </Typography>
          <Box sx={{ display: "flex" }}>
            <SearchBox />
            {/* //Notification Dialog code */}
            <NotificationMenu />

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src={Avtr} />
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => handleNavigation(setting)}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          open={mobileOpen}
          // container={container}
          variant="temporary"
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "block", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: [1],
            }}
            onClick={handleDrawerToggle}
          >
            <Box
              component="img"
              sx={{
                height: "38px",
              }}
              alt="The house from the offer."
              style={{ cursor: "pointer" }}
              onClick={handleMainLogoClick}
              src={Img}
            />
          </Toolbar>
          <Divider />
          <List component="nav">
            {mainListItems}
            <Divider sx={{ my: 1 }} />
            {secondaryListItems}
          </List>
        </Drawer>
      </Box>
    </Box>
  );
}

DashboardDrawer.propTypes = {
  window: PropTypes.func,
};

export default DashboardDrawer;
